<template>
  <div class="container">
    <sys-filter :filters.sync="filters" :server="true" :items="items" :filtered_items.sync="filtered_items" @getItems="getItems"/>
    <div class="row pb-5">
      <sys-widget title="Cantidad de Retiros" :content="meta.total" icon="hand-holding-usd" />
      <sys-widget title="Monto estimado" :content="meta.total_amount | formatCurrency" icon="dollar-sign" color="secondary"/>
    </div>
    <sys-server-table :headers="headers" :tableData="tableData" :pagination="pagination" :items="items" :title="title" :error_message="error_message" :detail_route="detail_route" :create_route="create_route" @getItems="getItems" />
  </div>
</template>

<script>
import withdrawService from '@/services/withdraws'
import SysServerTable from '@/components/shared/ServerTable'
import SysFilter from '@/components/shared/Filter'
import SysWidget from '@/components/shared/Widget'
import formatCurrency from '@/filters/formatCurrency'
import reverseDate from '@/filters/reverseDate'

export default {
  name: 'Withdraws',

  components: { SysServerTable, SysFilter, SysWidget },
  created () {
    this.getItems()
  },
  data () {
    return {
      title: 'Retiros',
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Folio', value: 'contract_folio' },
        { text: 'Acreedor', value: 'investor_name' },
        { text: 'Monto de retiro', value: 'amount', filter: formatCurrency },
        { text: 'Fecha de retiro', value: 'date_retirement' },
        { text: 'Estatus', value: 'status' }
      ],
      items: [],
      filtered_items: [],
      error_message: 'There\'s nothing to show :c',
      detail_route: 'withdraw',
      create_route: 'withdraw_create',
      tableData: {
        draw: 0,
        length: 10,
        search: '',
        column: 0,
        dir: 'desc'
      },
      meta: {
        total: 0,
        total_amount: 0
      },
      pagination: {
        lastPage: '',
        currentPage: '',
        total: '',
        links: {},
        from: 1,
        to: 10
      },
      filters: [
        {
          id: 'investor_name',
          name: 'Acreedor',
          hint: 'Ver todos',
          icon: 'user',
          type: 'text',
          value: '',
          size: 4,
          validator: (item, value) => item.investor_name.toLowerCase().includes(value.toLowerCase())
        },
        {
          id: 'folio',
          name: 'Contrato-Anexo',
          hint: 'Contrato-Anexo',
          icon: 'file-contract',
          type: 'text',
          value: '',
          size: 4,
          validator: (item, value) => item.folio.toLowerCase().includes(value.toLowerCase())
        },
        {
          id: 'status',
          name: 'Estatus',
          hint: 'Todos',
          icon: 'list',
          type: 'select',
          value: '',
          options: [
            {value: 'Confirmado', text: 'Confirmado'},
            {value: 'Pendiente', text: 'Pendiente'},
            {value: 'Cancelado', text: 'Cancelado'}
          ],
          size: 4,
          validator: (item, value) => item.status.toLowerCase().includes(value.toLowerCase())
        },
        {
          id: 'amount_from',
          name: 'Monto de retiro desde',
          hint: '$0.00',
          icon: 'dollar-sign',
          type: 'number',
          size: 3,
          value: '',
          validator: (item, value) => item.amount >= value
        },
        {
          id: 'amount_to',
          name: 'Monto de retiro hasta',
          hint: '$0.00',
          icon: 'dollar-sign',
          type: 'number',
          size: 3,
          value: '',
          validator: (item, value) => item.amount <= value
        },
        {
          id: 'date_retirement_from',
          name: 'Fecha Desde',
          hint: 'dd/mm/yyyy',
          icon: 'calendar-alt',
          type: 'date',
          size: 3,
          value: '',
          validator: (item, value) => new Date(item.date_retirement) >= new Date(reverseDate(value))
        },
        {
          id: 'date_retirement_to',
          name: 'Fecha Hasta',
          hint: 'dd/mm/yyyy',
          icon: 'calendar-alt',
          type: 'date',
          size: 3,
          value: '',
          validator: (item, value) => new Date(item.date_retirement) <= new Date(reverseDate(value))
        }
      ]
    }
  },
  methods: {
    getItems (page = 1, filters = []) {
      this.tableData.draw++
      let params = this.tableData
      if (filters != null) {
        Object.assign(params, filters)
      } else {
        this.tableData = {
          draw: 1,
          length: 10,
          search: '',
          column: 0,
          dir: 'desc'
        }
        params = this.tableData
      }
      params.page = page
      withdrawService.list(params)
        .then(response => {
          let data = response
          this.items = data.data
          let meta = data.meta
          this.meta.total = meta.total
          this.meta.total_amount = meta.total_amount
          this.configPagination(data.meta.pagination)
        })
        .catch(errors => {
          console.log(errors)
        })
    },
    configPagination (data) {
      this.pagination.lastPage = data.total_pages
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.links = (data.links) ? data.links : {}
      this.pagination.to = data.count * data.current_page
      this.pagination.from = this.pagination.to - data.count + 1
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/withdraws/Withdraws.vue